/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_TimeInputs */

const en_gc_search_guides_what_is_gridcraft_time = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 min read`)
};

const zh_gc_search_guides_what_is_gridcraft_time = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读约 12 分钟`)
};

/**
* | output |
* | --- |
* | "12 min read" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_time = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_time(inputs)
	return zh_gc_search_guides_what_is_gridcraft_time(inputs)
});
export { gc_search_guides_what_is_gridcraft_time as "gc.search_guides.what_is_gridcraft.time" }